
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class RateFixingTaxGrid extends Serenity.EntityGrid<RateFixingTaxRow, any> {
        protected getColumnsKey() { return 'Purchase.RateFixingTax'; }
        protected getIdProperty() { return RateFixingTaxRow.idProperty; }
        protected getInsertPermission() { return RateFixingTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return RateFixingTaxRow.localTextPrefix; }
        protected getService() { return RateFixingTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}